import { getAppName } from "../../IssuesTab/navigation/viewPaths";
import { getIssueTypeEntitiesMap } from "@adsk/acc-issues-core/state/redux/ducks/issueTypes";
import { useSelector } from "@adsk/acc-issues-core/state/redux/hooks";
import { getProjectMemberDisplayName } from "@adsk/acc-issues-common/utils/user/oxygenUtils";
import {
  useRolesEntitiesMapByOxygenId,
  useCompaniesEntitiesMapByOxygenId,
} from "@adsk/acc-issues-common/hooks/data/projectMembersHooks";
import { Issue } from "@adsk/acc-issues-types";
import { useTranslations } from "@adsk/acc-issues-translations";
import { useFormattedUser } from "@adsk/alloy-provider";

export const useAssigneeName = (issue: Issue) => {
  const { formatDisplayUser } = useFormattedUser();
  const rolesEntitiesMap = useRolesEntitiesMapByOxygenId();
  const companiesEntitiesMap = useCompaniesEntitiesMapByOxygenId();
  const { T } = useTranslations();

  return (
    getProjectMemberDisplayName({
      formatDisplayUser,
      rolesEntitiesMap,
      companiesEntitiesMap,
      id: issue.assignedTo,
      T,
    }) || T.translate("issuesListItem.unassigned")
  );
};

export const getIssueUrl = ({
  projectId,
  issueId,
}: {
  projectId: string;
  issueId: string;
}) => {
  return `/${getAppName()}/issues/projects/${projectId}/issues?issueId=${issueId}`;
};

export const useIssueTypeCode = (issueTypeId?: string) => {
  const issueTypeEntitiesMap = useSelector(getIssueTypeEntitiesMap);
  const issueType = issueTypeId ? issueTypeEntitiesMap[issueTypeId] : undefined;
  return issueType ? issueType.code : undefined;
};
